import UIButton from 'UIComponents/button/UIButton';
import { track as dashboardTracker, EVENTS
// @ts-expect-error untyped dependency
} from 'dashboard-ui-components/tracking/DashboardUITracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dependency
import { refreshReportSuccess } from '../../../actions/DashboardActions';
import { useWidgetContext } from '../WidgetContext';
// @ts-expect-error untyped dependency
import { getId as getReportId } from 'reporting-action-components/data/schemas/reportSchema';
// @ts-expect-error untyped dependency
import { getId as getDashboardId } from 'reporting-action-components/data/schemas/reportSchema';
import { jsx as _jsx } from "react/jsx-runtime";
const RefreshIframeAction = () => {
  const {
    dashboard,
    report
  } = useWidgetContext();
  const reportId = getReportId(report);
  const dashboardId = getDashboardId(dashboard);
  const handleClickRefresh = () => {
    dashboardTracker(EVENTS.clickIframeAction, {
      actionType: 'view',
      action: 'refresh',
      object: 'iframe',
      assetType: 'dashboard',
      interactionSource: 'widget',
      interactionWith: 'asset-action'
    });
    refreshReportSuccess({
      reportId,
      dashboardId
    });
  };
  return /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary-light",
    size: "extra-small",
    onClick: handleClickRefresh,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "iframeWidget.refresh.button"
    })
  }, "refresh-iframe");
};
export default RefreshIframeAction;